/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { Store } from 'redux';
import { IPropertiesValidator } from './ValidatorTypes';
import { IState, IStateMetadataError } from '../store/types/StateTypes';
import MetadataState from '../enums/MetadataState';

class ParameterNameValidator implements IPropertiesValidator {
    currentStore: Store;

    constructor(store: Store) {
        this.currentStore = store;
    }

    validate(properties: any) {
        const state: IState = this.currentStore.getState();
        const params = (properties && properties.params) || state.params;

        if (params && state.metadataState !== MetadataState.LOADING && (state.levelsLayout.rows.length || state.levelsLayout.columns.length)) {
            const paramNames = state.filterParameters.map((parameter) => (parameter.name));

            return Object.keys(params).reduce((memo, param) => (
                memo || paramNames.find((existing) => (existing === param)) ? null : {
                    message: `Unknown parameter: ${param}`,
                    errorCode: 'parameter.unknown',
                    parameters: [
                        param,
                        paramNames
                    ]
                } as IStateMetadataError
            ), null as IStateMetadataError | null);
        }

        return null;
    }
}

export default ParameterNameValidator;
